const validate = values => {
  const errors = {}
  if (values.new_password && values.new_password2) {
    if (values.new_password !== values.new_password2){
      errors.new_password2 = gettext('Два поля с паролями не совпадают.');
    }
  }
  return errors;
}

export default validate;